import { createFileRoute, redirect } from "@tanstack/react-router";
import { withLocale } from "~/lib/utils/with-locale";

export const Route = createFileRoute("/advertiser/_main/")({
  beforeLoad: () => {
    throw redirect({
      to: withLocale("/locations"),
    });
  },
  component: Home,
});

function Home() {
  // This should never render because we redirect in `beforeLoad`,
  // but keeping a component avoids runtime warnings.
  return null;
}
